import { type RefObject, useEffect, useMemo, useState } from "react";
import { useResizeObserver } from "widgets/hooks";

import { getRangeLength, rangeNormalize } from "../../../app-utils/range.js";

interface TrackRange {
  start: number;
  stop: number;
}

export const useTrackRefSize = (ref: RefObject<Element | null>, range: TrackRange = { start: 0, stop: 0 }) => {
  const boxSize = useResizeObserver(ref);
  const [width, setWidth] = useState<number>(1);

  useEffect(() => {
    if (boxSize) setWidth(Math.min(boxSize?.scrollWidth, boxSize?.width));
  }, [boxSize]);

  return useTrackSize(width, range);
};

export const useTrackSize = (width: number, range: TrackRange = { start: 0, stop: 0 }) => {
  const normalize = useMemo(() => rangeNormalize(width)(range), [width, range]);
  const baseWidth = useMemo(
    () => (normalize((range?.stop ?? 0) + 1) - normalize(range?.start ?? 0)) / getRangeLength(range),
    [normalize, range],
  );

  return { width, normalize, baseWidth };
};
